<template>
    <div>
        <K2Row class="">
            <K2Row align="center" class="me-2 search-wrap" v-for="item in filterList" :key="item.label">
                <span class="label-control me-2 ">{{item.label}}</span>
                <el-select class="search-wrap" v-model="item.selected" :placeholder="item.placeholder" size="small"
                           @change="value=>handleFilterChange(value, item.label)" v-if="item.optionList !== undefined" >
                    <el-option
                            v-for="d in item.optionList"
                            :key="d.id"
                            :label="d.label"
                            :value="d.id">
                    </el-option>
                </el-select>
              <div v-else-if="dateType === 'daterange'" >
                <el-date-picker

                                size="small"
                                v-model="item.selected"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="From"
                                end-placeholder="End"
                                format="dd/MM/yyyy"
                                value-format="dd/MM/yyyy"
                                @change="value=>handleFilterChange(value.toString(), item.label)"
                >
                </el-date-picker>
              </div>
              <div v-else >
                <el-date-picker

                  size="small"
                  v-model="item.selected"
                  placeholder="Select"
                  v-bind:type="dateType"
                  @change="value=>handleFilterChange(value.toString(), item.label)"

                >
                </el-date-picker>
              </div>

            </K2Row>
            <K2Button :background="uiVariable.color.button2" size="small" @onclick="handleFilterList">
                {{lang("Search")}}
            </K2Button>
            <K2Button :background="uiVariable.color.secondary" size="small" @onclick="handleReset" class="ms-2">
                {{lang("Clear")}}
            </K2Button>
        </K2Row>
    </div>
</template>

<script>
    import uiVariable from "../../config/uiVariable";
    import K2Row from "../k2Row/k2Row";
    import K2Button from "../k2Button/k2Button";
    import {lang} from "../../locale";
    export default {
      name: "K2Filter",
      components: {K2Button, K2Row},
      props: ["onFilter", "filterList", "onFilterChange","dateType"],

      data() {
          return {
              uiVariable: uiVariable,
              currentType: "",
            };
        },
        mounted() {
        },
        methods: {
            lang,
            handleFilterChange(value, type) {
                this.currentType = type;
                if (type === "Level") {
                    this.$emit("onFilterChange", value);
                }
            },
            handleFilterList() {
                this.$emit("onFilter", this.currentType);

            },
            handleReset() {
                this.filterList.forEach(d => {
                    d.selected = null;
                });
                this.$emit("onFilter", null);
            }
        }
    };
</script>